import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppFilter } from "../../../models/app-filter.model";
import { AbPreCadastro } from "app/abstract/full-pages/pre-cadastro/pre-cadastro.abstract";

@Injectable({ providedIn: 'root' })
export class PreCadastroService extends AbPreCadastro {
  opConta: string[] = ['POR_CEP', 'POR_NOME', 'POR_CODIGO']

  constructor(http: HttpClient) {
    super(http);
  }

  public salvarPreCadastro(obj): Observable<any> {
    return this.save('public/pessoas_pre_cadastro/', obj);
  }

  public unidadePreCadastro(obj): Observable<any> {
    return this.save('public/unidades_pre_cadastro/', obj);
  }

  public veiculoPreCadastro(obj): Observable<any> {
    return this.save('public/veiculos_pre_cadastro/', obj);
  }

  public aprovarPreCadastro(aprovado, id): Observable<any> {
    return this.get(`public/pessoas_pre_cadastro/aprovar/${aprovado}/${id}`);
  }


  public getAllMarcasVeiculosPreCadastro(tipoVeiculo: String): Observable<any> {
    return this.get(`public/veiculos_pre_cadastro/marcas_veiculos/tipoveiculo/${tipoVeiculo}`);
  }

  public getPessoaPreCadastro(id: number): Observable<any> {
    return this.get(`public/pessoas_pre_cadastro/${id}`);
  }

  public getAllPessoaPreCadastroPendentes(): Observable<any> {
    return this.get(`public/pessoas_pre_cadastro/pendentes`);
  }

  public getAllPessoaPreCadastroByFilter(filter: AppFilter): Observable<any> {
    return this.get(`public/pessoas_pre_cadastro/filter/${filter.encode()}`);
  }

  public getAllMoradoresByPessoaPreCadastro(id: number): Observable<any> {
    return this.get(`public/pessoas_pre_cadastro/moradores/${id}`);
  }

  public finalizarPreCadastro(uuid: string) {
    return this.get(`public/pessoas_pre_cadastro/finalizar/${uuid}`);
  }

  public getVeiculosPreCadastroByPessoaPreCadastroId(id: number) {
    return this.get(`public/veiculos_pre_cadastro/pessoa_pre_cadasto_id/${id}`);
  }

  public getUnidadesPreCadastroByPessoaPreCadastroId(id: number) {
    return this.get(`public/unidades_pre_cadastro/`, id);
  }

  public excluirPessoaPreCadastro(id: number) {
    return this.delete(`public/pessoas_pre_cadastro/`, id);
  }

  public excluirUnidadePreCadastro(id: number) {
    return this.delete(`public/unidades_pre_cadastro/`, id);
  }

  public excluirVeiculoPreCadastro(id: number) {
    return this.delete(`public/veiculos_pre_cadastro/`, id);
  }

  public emailDuplicado(id: number, email: string): Observable<any> {
    return this.get(`public/pessoas_pre_cadastro/email_duplicado/${id}/${email}`);
  }
}
